import { SetState } from 'zustand';

export interface IObData {
    customerId: string;
    authorizedUserId: string;
    lastStepVisit: number;
    consentFormData?: FormData | null;
    accessToken?: string;
}

export enum MfaType {
    SMS = 'SMS',
    VOICE = 'VOICE'
}

export interface IMfaData {
    authorizedExternalId: string;
    authorizedUserFullName: string;
    customerBusinessName: string;
    customerFirstName: string;
    customerId: string;
    customerLastName: string;
    mfaDestination: string;
    mfaType: MfaType;
}
export interface IFormData {
    phone: string;
    firstName: string;
    lastName: string;
}
export interface IAccountantSlice {
    obData: IObData;
    mfaData: IMfaData | null;
    formData: IFormData | null;
    setObData: (data: IObData) => void;
    setMfaData: (data: IMfaData) => void;
    setFormData: (data: IFormData) => void;
    resetOnboardingData: () => void;
}

const createAccountantObSlice = (set: SetState<IAccountantSlice>) => ({
  obData: {
    customerId: '',
    authorizedUserId: '',
    lastStepVisit: 1,
    consentFormData: null,
    accessToken: '',
  },
  mfaData: null,
  formData: null,
  setObData: (data: IObData) => set({ obData: data }),
  setMfaData: (data: IMfaData) => set({ mfaData: data }),
  setFormData: (data: IFormData) => set({ formData: data }),
  resetOnboardingData: () => {
    set({
      obData: {
        customerId: '',
        authorizedUserId: '',
        lastStepVisit: 1,
        consentFormData: null,
        accessToken: '',
      },
      mfaData: null,
      formData: null,
    });
  },
});

export default createAccountantObSlice;
